import { X } from 'lucide-react'
import { useEffect } from 'react'

interface ImageModalProps {
	isOpen: boolean
	onClose: () => void
	imageUrl: string
	alt: string
}

export default function ImageModal({
	isOpen,
	onClose,
	imageUrl,
	alt,
}: ImageModalProps) {
	useEffect(() => {
		const handleEscape = (e: KeyboardEvent) => {
			if (e.key === 'Escape') onClose()
		}

		if (isOpen) {
			document.addEventListener('keydown', handleEscape)
			document.body.style.overflow = 'hidden'
		}

		return () => {
			document.removeEventListener('keydown', handleEscape)
			document.body.style.overflow = 'unset'
		}
	}, [isOpen, onClose])

	if (!isOpen) return null

	return (
		<div
			className="fixed inset-0 z-50 flex items-center justify-center bg-black/90"
			onClick={onClose}>
			<button
				className="hover:text-white80 absolute right-4 top-4 text-white"
				onClick={onClose}>
				<X size={32} />
			</button>
			<div className="relative max-h-[90vh] max-w-[90vw]">
				<img
					src={imageUrl}
					alt={alt}
					className="max-h-[90vh] max-w-[90vw] object-contain"
				/>
			</div>
		</div>
	)
}
